import type { ReactNode } from 'react'
import type { LucideIcon } from 'lucide-react'
import { cn } from '../cn'

/** Toolbar-sized CTAs for PageEmptyState actions (matches Risk Register). */
export const pageEmptyStateOutlineButtonClass =
  'h-8 rounded-sm border-border-divider px-3 text-[12px]'
export const pageEmptyStatePrimaryButtonClass =
  'h-8 rounded-sm bg-primary px-3 text-[12px] text-primary-foreground hover:bg-primary/90'

interface PageEmptyStateProps {
  icon: LucideIcon
  title: string
  description?: string
  /** Secondary line below description (e.g. disclaimers, hints). */
  footnote?: string
  /** Optional CTA buttons — omit for read-only empty states (e.g. auditor views). */
  actions?: ReactNode
  className?: string
}

export function PageEmptyState({
  icon: Icon,
  title,
  description,
  footnote,
  actions,
  className,
}: PageEmptyStateProps) {
  return (
    <div
      className={cn(
        'border-border-divider flex flex-col items-center justify-center rounded-sm border border-dashed bg-card px-6 py-16 text-center',
        className
      )}
    >
      <Icon className='text-text-disabled mb-3 h-10 w-10' strokeWidth={1.5} />
      <p className='font-body text-text-body text-[13px] font-medium'>
        {title}
      </p>
      {description ? (
        <p className='font-body text-muted-foreground mx-auto mt-1 max-w-md text-[12px]'>
          {description}
        </p>
      ) : null}
      {actions ? (
        <div className='mt-4 flex items-center justify-center gap-3'>
          {actions}
        </div>
      ) : null}
      {footnote ? (
        <p className='font-body text-text-placeholder mx-auto mt-4 max-w-md text-[11px] italic'>
          {footnote}
        </p>
      ) : null}
    </div>
  )
}
